import axios from 'axios';
import { Contact } from '../models/contact.model';

export class ContactService {
  private apiUrl!: string;
  private contacts!: Contact[];

  constructor() {
    this.apiUrl = import.meta.env.VITE_APP_onBackstageAPI + 'contacts/';
  }

  public async getAll(): Promise<Contact[]> {
    try {
      if (!this.contacts) {
        const response = await axios.get(this.apiUrl);
        this.contacts = response.data;
      }

      return this.contacts;
    } catch (exception) {
      console.info('request failed to fetch contacts ', exception);

      return new Array<Contact>();
    }
  }
}
